import { createFileRoute } from '@tanstack/react-router';

import { F29TemplatesPage } from '@/features/f29/components/f29-templates-page';

export const Route = createFileRoute('/_app/f29/templates')({
  component: F29TemplatesPage,
});
